import { useSelector } from 'react-redux'
import type { State } from '../../Slice/index.js'
import { applicationSlice } from '../../Slice/Application/ApplicationSlice.js'
import { createSelector } from '@reduxjs/toolkit'
import type { IBlockingRequest } from '../../../Model/Message/IBlockingRequest.js'

export const useFirstBlockingRequest = (): IBlockingRequest | undefined => {
  return useSelector(getFirstBlockingRequest)
}

const selectBlockingRequests = (state: typeof State) => state[applicationSlice.name].blockingRequests

export const getFirstBlockingRequest = createSelector(selectBlockingRequests, (blocking) => (blocking.length > 0 ? blocking[0] : undefined))
